import React from 'react';
import HousekeepingStatusSelect from 'components/HousekeepingStatusSelect';

import {HOUSEKEEPING_STATUS_OPTIONS, PURPOSES} from 'ducks/allocations';

import './styles.css';
const TOOLTIP_NAME = 'roomTypeTooltip';

const ROOM_PURPOSES_COLOR_MAPPER = {
  ['Long stay']: '#B9E3AA',
  ['Short stay']: '#BFBEEF',
  ['Extended stay']: '#FFBD5E',
  ['Corporate']: '#CCE1FF',
  ['Guest']: '#FFB1D7'
};

class TimelineGroup extends React.Component<any> {
  render() {
    const {group, openRoomNotesModal, onRoomCleaningStatusChange} = this.props;
    const cleaningStatusIsOOO =
      group.cleaningStatus === HOUSEKEEPING_STATUS_OPTIONS.OUT_OF_ORDER;
    return (
      <div className="TimelineGroup colab-row-space-between">
        <div className="TimelineGroup__room_purpose_type colab-clickable">
          <div data-tip={PURPOSES[group.purpose]} data-for={TOOLTIP_NAME}>
            <div
              className="ellipse"
              style={{
                backgroundColor:
                  ROOM_PURPOSES_COLOR_MAPPER[PURPOSES[group.purpose]]
              }}
            />
          </div>
        </div>
        <div
          className="TimelineGroup__title colab-clickable colab-bold "
          onClick={() => openRoomNotesModal({roomId: group.roomId})}>
          {group.title}
        </div>
        <div className="TimelineGroup__status">
          {!group.dummy && (
            <HousekeepingStatusSelect
              onChange={option =>
                onRoomCleaningStatusChange(option.value, group.roomId)
              }
              value={group.cleaningStatus}
              disabled={cleaningStatusIsOOO}
            />
          )}
        </div>
        <div
          className="TimelineGroup__type"
          data-tip={group.rightTitle}
          data-for={TOOLTIP_NAME}>
          {group.rightTitle}
        </div>
      </div>
    );
  }
}

export default TimelineGroup;
